import { render, staticRenderFns } from "./Infografica.vue?vue&type=template&id=517b1e3d"
import script from "./Infografica.vue?vue&type=script&lang=js"
export * from "./Infografica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports